(function () {
  const calculators = document.querySelectorAll('[data-cost-savings-calculator]');

  function formatCurrency(value) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(value);
  }

  function updateSliderBackground(input) {
    const value = ((input.value - input.min) / (input.max - input.min)) * 100;
    input.style.setProperty('--value', `${value}%`);
  }

  calculators.forEach((calculator) => {
    const currentVacuumSelect = calculator.querySelector('[data-current-vacuum]');
    const newVacuumSelect = calculator.querySelector('[data-new-vacuum]');
    const hourlyWageNumber = calculator.querySelector('[data-hourly-wage]');
    const numEmployeesNumber = calculator.querySelector('[data-num-employees]');
    const hoursPerDayNumber = calculator.querySelector('[data-hours-per-day]');
    const rangeInputs = calculator.querySelectorAll('input[type="range"]');
    const numberInputs = calculator.querySelectorAll('input[type="number"]');
    const savingsDisplay = calculator.querySelector('[data-savings-display]');
    const breakdownButton = calculator.querySelector('[data-breakdown-button]');
    const breakdown = calculator.querySelector('[data-breakdown]');
    let workingDays = 260;

    function updateBreakdown() {
      const currentVacuum = parseFloat(currentVacuumSelect.value);
      const newVacuum = parseFloat(newVacuumSelect.value);
      const hourlyWage = parseFloat(hourlyWageNumber.value) || 0;
      const numEmployees = parseFloat(numEmployeesNumber.value) || 0;
      const hoursPerDay = parseFloat(hoursPerDayNumber.value) || 0;
      const currentVacuumTitle = currentVacuumSelect.options[currentVacuumSelect.selectedIndex].text;
      const newVacuumTitle = newVacuumSelect.options[newVacuumSelect.selectedIndex].text;
      const currentVacuumLabor = hourlyWage * hoursPerDay * numEmployees;
      const newVacuumLabor = currentVacuumLabor;
      const currentVacuumCost = currentVacuumLabor * 240;
      const newVacuumCost = newVacuumLabor * 240;

      calculator.querySelector('[data-current-vacuum-rate]').innerText = `${currentVacuum} sq. ft/hr (${currentVacuumTitle})`;
      calculator.querySelector('[data-new-vacuum-rate]').innerText = `${newVacuum} sq. ft/hr (${newVacuumTitle})`;
      calculator.querySelector('[data-current-vacuum-labor]').innerText = formatCurrency(currentVacuumLabor);
      calculator.querySelector('[data-new-vacuum-labor]').innerText = formatCurrency(newVacuumLabor);
      calculator.querySelector('[data-current-vacuum-cost]').innerText = formatCurrency(currentVacuumCost);
      calculator.querySelector('[data-new-vacuum-cost]').innerText = formatCurrency(newVacuumCost);
    }

    function calculateSavings() {
      const currentVacuum = parseFloat(currentVacuumSelect.value);
      const newVacuum = parseFloat(newVacuumSelect.value);
      const hourlyWage = parseFloat(hourlyWageNumber.value) || 0;
      const numEmployees = parseFloat(numEmployeesNumber.value) || 0;
      const hoursPerDay = parseFloat(hoursPerDayNumber.value) || 0;
      const sqFtDifference = newVacuum - currentVacuum;
      const costSavings = (sqFtDifference / currentVacuum) * hourlyWage * hoursPerDay * workingDays * numEmployees;

      savingsDisplay.innerText = `*Total Savings: ${formatCurrency(costSavings)}`;
      updateBreakdown();
    }

    function setActiveButton(button) {
      calculator.querySelectorAll('.button-group button').forEach((savingsButton) => savingsButton.classList.remove('active'));
      button.classList.add('active');
    }

    rangeInputs.forEach((rangeInput) => {
      updateSliderBackground(rangeInput);
      rangeInput.addEventListener('input', () => {
        const numberInput = calculator.querySelector(`[data-range-id="${rangeInput.id}"]`);
        if (numberInput) numberInput.value = rangeInput.value;
        updateSliderBackground(rangeInput);
        calculateSavings();
      });
    });

    numberInputs.forEach((numberInput) => {
      numberInput.addEventListener('input', () => {
        const associatedRange = calculator.querySelector(`#${CSS.escape(numberInput.dataset.rangeId)}`);
        if (associatedRange) {
          associatedRange.value = numberInput.value;
          updateSliderBackground(associatedRange);
        }
        calculateSavings();
      });
    });

    currentVacuumSelect.addEventListener('change', calculateSavings);
    newVacuumSelect.addEventListener('change', calculateSavings);

    breakdownButton.addEventListener('click', () => {
      breakdown.hidden = !breakdown.hidden;
      breakdownButton.innerText = breakdown.hidden ? 'Show full breakdown' : 'Hide full breakdown';
      updateBreakdown();
    });

    calculator.querySelectorAll('[data-days]').forEach((button) => {
      button.addEventListener('click', () => {
        workingDays = parseInt(button.dataset.days, 10);
        setActiveButton(button);
        calculateSavings();
      });
    });

    calculateSavings();
  });
})();
